import { Settings } from "../../../Settings";
import Path from "../Path";
import PathPlanJumpLeft from "../plan/PathPlanJumpLeft";
import PathPlanJumpRight from "../plan/PathPlanJumpRight";
import PathTemplatePattern from "./PathTemplatePattern";


// PATTERN VALUES:
// S start
// P path
// E end
// X closed
// O open
// 8 open or path
// . ignore

export default class PatternJump0Side2 extends PathTemplatePattern {
    constructor() {
        super([
            '.O.',     // ignore   open   ignore
            'S8E',     // start    o|p    end
            'X8.'     //  ignore   o|p    ignore
        ],
        true);  // true to flip left/right
    }

    /**
     * Returns the minimum number of path steps required by this pattern to be applied.
     * @override
     * @returns {number}
     */    
    getMinRequiredPathSteps() {
        return 2;
    }

    /**
     * @override
     * @param {Path} path
     * @param {number} pathIndex The path index.
     * @returns {PathPlan}
     */
    getPathPlan(path, pathIndex) {
        const start = path.tiles[pathIndex];

        const targetCol = start.getTileCol() + 2; // end tile is 2 columns to the right of start
        const targetRow = start.getTileRow();     // end tile is on same row as start
        const endIndex = this.findTilePathIndex(path, pathIndex + 2, targetCol, targetRow);  // +2: we know the end is at least 2 steps away in the path.
        if (endIndex < 0) {
            console.log('PathTemplatePatternJumpSide2() getPathPlan() failed to find end tile');
            return null;
        }

        const end = path.tiles[endIndex];
        const steps = endIndex - pathIndex;

        return new PathPlanJumpRight(start, end, steps, Settings.tile.halfSize);
    }

    /**
     * @override
     * @param {Path} path
     * @param {number} pathIndex The path index.
     * @returns {PathPlan}
     */
    getPathPlanFlipped(path, pathIndex) {
        const start = path.tiles[pathIndex];
        
        const targetCol = start.getTileCol() - 2; // end tile is 2 columns to the left of start
        const targetRow = start.getTileRow();     // end tile is on same row as start
        const endIndex = this.findTilePathIndex(path, pathIndex + 2, targetCol, targetRow);  // +2: we know the end is at least 2 steps away in the path.
        if (endIndex < 0) {
            return null;
        }

        const end = path.tiles[endIndex];
        const steps = endIndex - pathIndex;

        return new PathPlanJumpLeft(start, end, steps, Settings.tile.halfSize);
    }

    /**
     * @override
     * @returns {string}
     */
    toString() {
        return 'PatternJump0Side2';
    }
}